import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import './list.scss';
import http from '@/server';
import { useHistory } from 'react-router-dom';
import QRCode from 'qrcode.react';
import Print from '@/utils/print';
// import qrcode from 'qrcode.react';
// import jQuery from 'jquery';

function Detail() {
  let history = useHistory();
  const [newsDerail, setNewsDetail] = useState();
  const [id, setID] = useState();
  // eslint-disable-next-line no-unused-vars
  const [_refs, setRefs] = useState();
  const [isShowQrCode, setIsShowQrCode] = useState(false);
  const idRef = useRef(id);
  idRef.current = id;

  useEffect(() => {
    const onPopState = () => {
      window.location.reload();
    };
    window.addEventListener('popstate', onPopState, false);

    const unlisten = history.listen((route) => {
      if (
        decodeURI(getQueryVariable('id')) &&
        idRef.current !== decodeURI(getQueryVariable('id'))
      ) {
        setID(decodeURI(getQueryVariable('id')));
      }
    });

    return () => {
      window.removeEventListener('popstate', onPopState, false);
      unlisten();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (decodeURI(getQueryVariable('title')) === '网站公告') {
      getDetail();
    } else {
      getNewsDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // 获取新闻详情数据
  const getNewsDetail = () => {
    let params = {
      id: decodeURI(getQueryVariable('id')),
      cid: decodeURI(getQueryVariable('cid')),
    };
    http.get('/news/achieve_news_detail', params).then((res) => {
      setNewsDetail(res.data);
      document.title = '江苏省通信学会 - ' + res.data.title;
    });
  };
  // 获取公告详情数据
  const getDetail = () => {
    let params = {
      id: decodeURI(getQueryVariable('id')),
    };
    http.get('/newgg/achieve_news_detail', params).then((res) => {
      setNewsDetail(res.data);
      document.title = '江苏省通信学会 - ' + res.data.title;
    });
  };

  // 截取url参数
  const getQueryVariable = (variable) => {
    let query = decodeURI(window.location.search.substring(1));
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  };

  const changePage = (type) => {
    let params = {
      id: '',
      cid: decodeURI(getQueryVariable('cid')),
    };
    if (type === 'last') {
      params.id = newsDerail.last_id;
    } else if (type === 'next') {
      params.id = newsDerail.next_id;
    }

    if (decodeURI(getQueryVariable('title')) === '网站公告') {
      http.get('/newgg/achieve_news_detail', params).then((res) => {
        setNewsDetail(res.data);
      });
    } else {
      http.get('/news/achieve_news_detail', params).then((res) => {
        setNewsDetail(res.data);
      });
    }
  };

  const qrcode = () => {
    setIsShowQrCode(!isShowQrCode);
    // let path = window.location.href; //获取页面的链接
    // if (jQuery('#weixin').html() == '') {
    //   jQuery('#weixin').qrcode({
    //     text: path, //设置二维码内容
    //     //render: "table", //设置渲染方式
    //     width: 185, //设置宽度,默认生成的二维码大小是 256×256
    //     height: 185, //设置高度
    //     typeNumber: -1, //计算模式
    //     background: '#ffffff', //背景颜色
    //     foreground: '#000000', //前景颜色
    //   });
    // }
  };

  const print = () => {
    const printBox = document.getElementById('printBox');
    Print(printBox);
  };

  //确认打印
  // const printOk = () => {
  //   //获取打印区域
  //   const printDiv = document.getElementById('printDiv');
  //   const iframe = document.createElement('IFRAME');
  //   let doc = null;
  //   iframe.setAttribute(
  //     'style',
  //     'position:absolute;width:0px;height:0px;left:500px;top:500px;',
  //   );
  //   document.body.appendChild(iframe);

  //   doc = iframe.contentWindow.document;
  //   // 打印时去掉页眉页脚
  //   doc.write(
  //     '<style media="print">@page {size: auto;  margin: 0mm; }</style>',
  //   );

  //   doc.write(printDiv.innerHTML);
  //   doc.close();
  //   // 获取iframe的焦点，从iframe开始打印
  //   iframe.contentWindow.focus();
  //   iframe.contentWindow.print();
  //   if (navigator.userAgent.indexOf('MSIE') > 0) {
  //     //打印完删除iframe
  //     document.body.removeChild(iframe);
  //   }
  // };

  return (
    <div className="detailBox" ref={(el) => setRefs(el)} id="printBox">
      {newsDerail ? (
        <>
          <h2>{newsDerail.title}</h2>
          <div className="aut">
            来源：<span>{newsDerail.source} </span>
            发布时间：<span>{newsDerail.release_time} </span>
            浏览量：<span>{newsDerail.hits}</span>
            {/* <Button
              type="text"
              onClick={() => {
                history.go(-1);
                window.close();
              }}
            >
              [关闭]
            </Button> */}
            {/* <ReactToPrint
              trigger={() => (
                <Button type="text">
                  <img
                    className="qrcode"
                    src={require('@/assets/detail/print.png').default}
                    alt=""
                  />
                </Button>
              )}
              content={() => refs}
            /> */}
            <Button type="text" onClick={print} style={{ marginLeft: '5px' }}>
              <img
                className="qrcode"
                src={require('@/assets/detail/print.png').default}
                alt=""
              />
            </Button>
            {/* <span className="fxd"> */}
            <Button type="text" onClick={qrcode}>
              <img
                className="qrcode"
                src={require('@/assets/detail/wx.png').default}
                alt=""
              />
            </Button>
            {/* </span> */}
          </div>
          {/* {newsDerail.images.length > 0
            ? newsDerail.images.map((item, index) => {
                return <img key={index} src={item} alt="" />;
              })
            : null} */}
          <div className="content-box">
            <div
              id="printDiv"
              className="content"
              dangerouslySetInnerHTML={{ __html: newsDerail.content }}
            ></div>
            {newsDerail &&
            newsDerail.attachment &&
            newsDerail.attachment.length > 0
              ? newsDerail.attachment.map((item, index) => {
                  return (
                    <div className="attachment" key={index}>
                      <img
                        src={require('@/assets/detail/file.png').default}
                        alt=""
                      />
                      <span
                        onClick={() => {
                          window.open(item.file_url);
                        }}
                      >
                        {item.orig_name} (
                        {item.file_size.length > 3
                          ? (Number(item.file_size) / 1024).toFixed(2) + 'KB'
                          : item.file_size.length > 6
                          ? (Number(item.file_size) / (1024 * 1024)).toFixed(
                              2,
                            ) + 'MB'
                          : item.file_size + 'B'}
                        )
                      </span>
                    </div>
                  );
                })
              : null}
          </div>
          <div className="f-btn">
            {newsDerail && newsDerail.last_title ? (
              <span onClick={changePage.bind(this, 'last')}>
                上一篇：{newsDerail.last_title}
              </span>
            ) : null}
            {newsDerail && newsDerail.next_title ? (
              <span onClick={changePage.bind(this, 'next')}>
                下一篇：{newsDerail.next_title}
              </span>
            ) : null}
          </div>
        </>
      ) : null}

      <div id="WX" style={{ display: isShowQrCode ? 'block' : 'none' }}>
        <div className="bd_weixin_popup_head">
          <span>分享到微信朋友圈</span>
          <button
            className="bd_weixin_popup_close"
            onClick={() => {
              setIsShowQrCode(!isShowQrCode);
            }}
            aria-label="关闭"
          >
            ×
          </button>
          <div id="weixin">
            <QRCode
              value={window.location.href} //value参数为生成二维码的链接
              size={185} //二维码的宽高尺寸
              fgColor="#000000" //二维码的颜色
            />
          </div>
          {/* <div className="bd_weixin_popup_foot">
            打开微信，点击底部的“发现”，
            <br />
            使用“扫一扫”即可将网页分享至朋友圈。
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Detail;
